<template>
    <div class="busWitnessCard" @click="$emit('click', item)">
        <div class="header">
            <div class="code">
                <img :src="require('@/assets/images/buswitnessCard_icon.png')" class="icon">
                {{ item.tradePlatfCode || item.businessCode }}
            </div>
            <div class="flowName" :class="/注册|计划/.test(item.flowName) ? 'flowGreen' : 'flowBlue'">
                {{ item.flowName }}
            </div>
        </div>
        <div class="title">
            <el-tag
                size="small"
                :hit="false"
                :type="formatterTagType(item.witnessStatus,'witnessStatus')"
            >
                {{ item.witnessStatusName }}
            </el-tag>
            <span class="name">{{ item.businessName }}</span>
        </div>
        <div class="row">
            <span class="key">所属交易中心：</span>
            <span class="value">{{ item.tradeName }}</span>
        </div>
        <div class="row">
            <span class="key">提交时间：</span>
            <span class="value">{{ item.processinstancecreatedate }}</span>
        </div>
        <div class="row">
            <span class="key">见证完成时间：</span>
            <span class="value">{{ item.finishedTime }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "busWitnessCard",
    props: {
        item: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
        }
    },
    methods: {
    },
}
</script>

<style lang="less" scoped>
.busWitnessCard{
    width: 100%;
    height: 199px;
    border-radius: 2px;
    border: 1px solid #60617026;
    background: #FFF;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    .header {
        height: 32px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .code {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-left: 16px;

            .icon {
                width: 16px;
                height: 16px;
                margin-right: 4px;
            }
        }

        .flowName {
            height: 24px;
            color: #FFFFFF;
            padding: 3px 4px 2px 16px;
            background-image: url("../../../assets/images/buswitnessCard_flow_green.png");
            background-position: center;
            background-repeat: no-repeat;
            background-size: 100% 100%;
        }
        .flowBlue {
            background-image: url("../../../assets/images/buswitnessCard_flow_blue.png");
        }
        .flowGreen {
            background-image: url("../../../assets/images/buswitnessCard_flow_green.png");
        }
    }
    .title {
        margin-bottom: 4px;
        margin-top: 8px;
        padding: 0 16px;
        .name {
            color: #000000;
            font-size: 16px;
            font-weight: 400;
            line-height: 26px;
            margin-left: 4px;
        }
    }
    .row {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: 10px;
        line-height: 22px;
        padding: 0 16px;
        .key{
            color: #000000d9;
        }
        .value{
            color: #6f7197;
        }
    }
}
</style>
